import {CloudIcon, ContainerIcon, ServerIcon, type Icon} from '@primer/octicons-react'
import {MessageCircleIcon} from '@github-ui/custom-icons/MessageCircleIcon'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import styles from '../../components/AgentTypeTrailingVisual.module.css'

/**
 * Default trailing visual for cloud-based agents.
 * Renders a CloudIcon, FF-gated behind copilot_mission_control_session_filters.
 */
export function DefaultTrailingVisual() {
  return <SessionTypeTrailingVisual icon={CloudIcon} label="Cloud session" testId="agent-type-trailing-visual-cloud" />
}

export function EnvironmentTrailingVisual() {
  return (
    <SessionTypeTrailingVisual
      icon={ServerIcon}
      label="Environment session"
      testId="agent-type-trailing-visual-environment"
    />
  )
}

export function SandboxTrailingVisual() {
  return (
    <SessionTypeTrailingVisual
      icon={ContainerIcon}
      label="Sandbox session"
      testId="agent-type-trailing-visual-sandbox"
    />
  )
}

export function ChatTrailingVisual() {
  return (
    <SessionTypeTrailingVisual icon={MessageCircleIcon} label="Chat session" testId="agent-type-trailing-visual-chat" />
  )
}

function SessionTypeTrailingVisual({icon: IconComponent, label, testId}: {icon: Icon; label: string; testId: string}) {
  if (
    !isFeatureEnabled('copilot_mission_control_session_filters') ||
    !isFeatureEnabled('copilot_mission_control_environment_list_icons')
  ) {
    return null
  }

  return (
    <span className={styles.wrapper} role="img" aria-label={label} data-testid={testId}>
      <IconComponent />
    </span>
  )
}
